import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-information-notice',
  templateUrl: './information-notice.component.html',
  styleUrls: ['./information-notice.component.scss'],
})
export class InformationNoticeComponent {
  @Input() header: string = '';
  @Input() text: string = '';
}
